import React from 'react';

import {REMOTE_CONFIG_PATHS} from '../../../constants/remoteConfigPaths';
import {DynamicContent} from '../../DynamicContent';
import './AsteriskDisclaimerTermsConditions.style.scss';

export const AsteriskDisclaimerTermsConditions = () => {
  return (
    <DynamicContent
      configPath={REMOTE_CONFIG_PATHS.TERMS_CONDITIONS.ASTERISK_DISCLAIMER}
      renderAsHtml={true}
    />
  );
};
